import { call, put, select } from 'redux-saga/effects';
import { updateDetailsFailure, updateDetailsSuccess } from '../actions';
import { updateDetails } from '../api';
import { UpdateDetailsRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { checkResponse } from 'store/utils';
import { fetchMeSuccess } from 'store/auth/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { getAuthUser } from 'store/auth/selectors';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* updateDetailsSaga(action: UpdateDetailsRequestAction) {
  try {
    let err: ApiError | null;

    const { user } = action.payload;
    const response: ApiResponse = yield call(updateDetails, user);

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('notifications.updated'),
      description: i18n.t('notifications.details-updated-successfully'),
      type: MessageStates.SUCCESS,
    };
    let newUser = user;
    const currentUser = yield select(getAuthUser);
    if (currentUser) {
      newUser = { ...currentUser, ...user };
    }
    yield put(turnMessageOn(message));
    yield put(updateDetailsSuccess());
    yield put(fetchMeSuccess(newUser, null));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(updateDetailsFailure());
  }
}
